import { BatchDeterminationContext } from '../../contexts/BatchDeterminationContext';
import { TABS } from '../../shared/constants/constants';
import ImportHistory from './importHistory/ImportHistory';
import SavedTemplates from './savedTemplates/SavedTemplates';
import { SovosButton, SovosPageLayout, SovosTabContent } from 'mosaic-react';
import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const BatchDeterminationPage: React.FC = () => {
	const [selectedTabId, setSelectedTabId] = useState<TABS>(TABS.IMPORT_HISTORY);
	const { getImportData } = useContext(BatchDeterminationContext);
	const navigate = useNavigate();

	const handleTabChange = (tabId: number) => {
		setSelectedTabId(tabId);
		if (tabId === TABS.IMPORT_HISTORY) {
			getImportData();
		}
	};

	return (
		<div>
			<SovosPageLayout
				pageTitle='Uploads'
				onTabChanged={handleTabChange}
				titleBarActions={[
					<SovosButton key='addTransaction' onClick={() => navigate('/import')}>
						Upload
					</SovosButton>,
				]}
			>
				<SovosTabContent TabProps={{ label: 'Uploaded files' }}>
					{selectedTabId === TABS.IMPORT_HISTORY && <ImportHistory />}
				</SovosTabContent>
				<SovosTabContent TabProps={{ label: 'Templates' }}>
					{selectedTabId === TABS.SAVED_TEMPLATE && <SavedTemplates />}
				</SovosTabContent>
			</SovosPageLayout>
		</div>
	);
};

export default BatchDeterminationPage;
